import React, { useState, useEffect, useRef } from 'react';
import './sub1.css'; // Import CSS for styling
import { FaArrowRight, FaArrowLeft } from "react-icons/fa";

const JobMember = ({ members }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const scrollContainerRef = useRef(null);

  const CARDS_PER_PAGE_MOBILE = 1; // 1 card per page in mobile
  const CARDS_PER_PAGE_DESKTOP = 6;

  // Detect mobile screen size
  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  // Calculate total pages
  const totalPages = isMobile
    ? Math.ceil(members.length / CARDS_PER_PAGE_MOBILE)
    : Math.ceil(members.length / CARDS_PER_PAGE_DESKTOP);

  // Get current page members
  const getCurrentPageMembers = () => {
    if (isMobile) {
      const startIndex = currentPage * CARDS_PER_PAGE_MOBILE;
      return members.slice(startIndex, startIndex + CARDS_PER_PAGE_MOBILE);
    } else {
      const startIndex = currentPage * CARDS_PER_PAGE_DESKTOP;
      return members.slice(startIndex, startIndex + CARDS_PER_PAGE_DESKTOP);
    }
  };

  // Handle scroll for mobile
  const handleScroll = () => {
    if (!scrollContainerRef.current || !isMobile) return;

    const scrollLeft = scrollContainerRef.current.scrollLeft;
    const cardWidth = scrollContainerRef.current.offsetWidth;
    const newPage = Math.round(scrollLeft / cardWidth);
    setCurrentPage(newPage);
  };

  // Go to specific page
  const goToPage = (pageIndex) => {
    setCurrentPage(pageIndex);

    if (isMobile && scrollContainerRef.current) {
      const containerWidth = scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: pageIndex * containerWidth,
        behavior: 'smooth'
      });
    } else {
      // Scroll to top for desktop
      window.scrollTo({
        top: document.querySelector('.job-members').offsetTop,
        behavior: 'smooth'
      });
    }
  };

  // Next page
  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      goToPage(currentPage + 1);
    }
  };

  // Previous page
  const prevPage = () => {
    if (currentPage > 0) {
      goToPage(currentPage - 1);
    }
  };

  return (
    <section className="job-members">
      <h2>Job Members</h2>
      <p>Full Time Maids,Baby Sitter,Driver,Cook</p>

      {/* Desktop View - Grid Layout */}
      {!isMobile && (
        <>
          <div className="member-grid">
            {getCurrentPageMembers().map((member, index) => (
              <div className="member-card" key={index}>
                <img src={member.image} alt={member.name} />
                <div className="member-details">
                  <h3>{member.name}</h3>
                  <p>Work: {member.work}</p>
                  <p>Experience: {member.experience}</p>
                  <p>Age: {member.age}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Desktop Pagination */}
          <div className="pagination-controls1">
            <button
              className="pagination-btn1"
              onClick={prevPage}
              disabled={currentPage === 0}
            >
              Previous
            </button>

            <div className="page-numbers1">
              {Array.from({ length: totalPages }).map((_, index) => (
                <button
                  key={index}
                  className={`page-number ${currentPage === index ? 'active' : ''}`}
                  onClick={() => goToPage(index)}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            <button
              className="pagination-btn1"
              onClick={nextPage}
              disabled={currentPage === totalPages - 1}
            >
              Next
            </button>
          </div>
        </>
      )}

      {/* Mobile View - Horizontal Scroll with 1 Card */}
      {isMobile && (
        <>
          <div className="mobile-slider-container">
            <button
              className="arrow-btn left-arrow"
              onClick={prevPage}
              disabled={currentPage === 0}
            >
              <FaArrowLeft />
            </button>

            <div
              className="member-scroll-container"
              ref={scrollContainerRef}
              onScroll={handleScroll}
            >
              <div className="member-scroll-content">
                {members.map((member, index) => (
                  <div className="member-card mobile-card" key={index}>
                    <img src={member.image} alt={member.name} />
                    <div className="member-details">
                      <h4>{member.name}</h4>
                      <p>Work: {member.work}</p>
                      <p>Experience: {member.experience}</p>
                      <p>Age: {member.age}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <button
              className="arrow-btn right-arrow"
              onClick={nextPage}
              disabled={currentPage === totalPages - 1}
            >
              <FaArrowRight />
            </button>
          </div>

          {/* Mobile Dot Pagination */}
          <div className="dot-pagination">
            {Array.from({ length: totalPages }).map((_, index) => (
              <button
                key={index}
                className={`dot ${currentPage === index ? 'active' : ''}`}
                onClick={() => goToPage(index)}
                aria-label={`Go to page ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default JobMember;